import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const MediaCarousel = {
  init() {
    const section = document.querySelector('.media-testimonials');
    if (!section) return;

    const container = section.querySelector('.swiper');

    let slidesMob = 2;
    if(document.querySelector('.media-testimonials__card.has-text')){
        slidesMob = 1;
    }
    new Swiper(container, {
        modules: [Pagination],
        loop: true,
        slidesPerView: slidesMob,
        spaceBetween: 48,
        centeredSlides: slidesMob === 2,
        grabCursor: true,
        pagination: {
            el: '.media-testimonials__pagination',
            clickable: true,
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 80,
                centeredSlides: true
            }
        }
    });
  }
};

export default MediaCarousel;
